import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest } from '../generalRequest';

const initialState = {
    shouldDisplayInvoiceList: false,
    shouldDisplaySingleInvoice: false,
    shouldDisplayMainUtilityView: true,
    isTransactionSuccessfullyStarted: false,
    isTransactionSuccessfullyCompleted: false,
    extraInvoiceListData: {},
    transactionId: '',
    isConfirmationDialogOpen: false,
    osheeInvoiceType: '',
    sentFrom: '',
    invoiceList: [],
    singleInvoice: {},
    extraData: [],
    isLoading: false,
    utilityName: '',
    listOfTaxes: [],
    franchaise: [],
    zone: [],
    sections: [],
    isSelphiCompleted: undefined,
    isSelphIDCompleted: undefined,
    operationId: '',
    sessionId: '',
    isUanatacaDialogOpen: false,
    isScaRequired: false,
    isScaDialogOpen: false,
    startTransactionResponse: '',
    pin: '',
    isScaCompleted: false
};

export const utilitySlice = createSlice({
    name: 'utility',
    initialState,
    reducers: {
        displayInvoiceList: (state) => {
            state.shouldDisplayInvoiceList = true
            state.shouldDisplaySingleInvoice = false
            state.shouldDisplayMainUtilityView = false
        },
        setSentFrom: (state, action) => {
            state.sentFrom = action.payload
        },
        setOsheeInvoiceType: (state, action) => {
            state.osheeInvoiceType = action.payload
        },
        setExtraInvoiceListData: (state, action) => {
            state.extraInvoiceListData = action.payload
        },
        setExtraData: (state, action) => {
            state.extraData = action.payload
        },
        displaySingleInvoice: (state) => {
            state.shouldDisplaySingleInvoice = true
            state.shouldDisplayInvoiceList = false
            state.shouldDisplayMainUtilityView = false
        },
        displayMainUtilityView: (state) => {
            state.shouldDisplaySingleInvoice = false
            state.shouldDisplayInvoiceList = false
            state.shouldDisplayMainUtilityView = true
        },
        setRequestData: (state, action) => {
            state.requestData = action.payload
        },
        changeConfirmationDialogState: (state) => {
            state.isConfirmationDialogOpen = !state.isConfirmationDialogOpen
        },
        setIsTransactionSuccessfullyStarted: (state, action) => {
            state.isTransactionSuccessfullyStarted = action.payload
        },
        setUtilityName: (state, action) => {
            state.utilityName = action.payload
        },
        clearUtilitySliceStateForBasicAccount: (state) => {
            state.shouldDisplayInvoiceList = false
            state.shouldDisplaySingleInvoice = true
            state.shouldDisplayMainUtilityView = false
            state.isTransactionSuccessfullyStarted = false
            state.isTransactionSuccessfullyCompleted = false
            state.transactionId = ''
            state.isConfirmationDialogOpen = false
            state.singleInvoice = {}
            state.extraData = []
            state.listOfTaxes = []
            state.isLoading = false
        },
        setIsSelphiCompleted: (state, action) => {
            state.isSelphiCompleted = action.payload
        },
        setIsSelphIDCompleted: (state, action) => {
            state.isSelphIDCompleted = action.payload
        },
        setOperationId: (state, action) => {
            state.operationId = action.payload
        },
        setSessionId: (state, action) => {
            state.sessionId = action.payload
        },
        openUanatacaDialog(state) {
            state.isUanatacaDialogOpen = true;
        },
        closeUanatacaDialog(state) {
            state.isUanatacaDialogOpen = false;
        },
        openScaDialog(state) {
            state.isScaDialogOpen = true;
        },
        closeScaDialog(state) {
            state.isScaDialogOpen = false;
        },
        setStartTransactionResponse: (state, action) => {
            state.startTransactionResponse = action.payload
        },
        setPin: (state, action) => {
            state.pin = action.payload
        },
        setTransId: (state, action) => {
            state.transactionId = action.payload
        },
        setScaRequired: (state, action) => {
            state.isScaRequired = action.payload
        },
        setIsScaCompleted: (state, action) => {
            state.isScaCompleted = action.payload
        },
        clearUtilitySliceState: (state) => {
            return {
                ...initialState,
                isUanatacaDialogOpen: state.isUanatacaDialogOpen
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            })
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            })
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                if (action.payload.endpoint === 'OSHEE/GetOSHEEInstaces') {
                    state.extraData = action.payload.response.products
                }
                else if (action.payload.endpoint === 'OSHEE/GetBillsForContractOSHEENew') {
                    state.invoiceList = action.payload.response.bills.map(bill => { return { Data: bill.Date, Serial: bill.Serial, Vlera: bill.Value + ' Leke' } })
                    state.shouldDisplayInvoiceList = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayMainUtilityView = false
                }
                else if (action.payload.endpoint === 'OSHEE/GetBill') {
                    const invoice = action.payload.response.bill
                    state.singleInvoice = {
                        'Nr. i Kontrates': invoice.ContractNo,
                        'Seriali i Fatures': invoice.Serie,
                        'Klienti': invoice.CustomerName,
                        'Muaji': invoice.Date,
                        'Vlera': invoice.Value + ' Leke',
                        'Kamata': invoice.Interest + ' Leke',
                        'Taksa': invoice.TvTax + ' Leke',
                        'Komisioni': invoice.Fee + ' Leke',
                        'Vlera totale': invoice.FinalValue + ' Leke'
                    }
                    state.shouldDisplaySingleInvoice = true
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = false
                }
                else if (action.payload.endpoint === 'OSHEE/StartTransaction') {
                    state.transactionId = action.payload.response.transID
                    state.isTransactionSuccessfullyStarted = true
                }
                else if (action.payload.endpoint === 'OSHEE/ConfirmTransaction') {
                    state.isTransactionSuccessfullyCompleted = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = true
                }
                /** ///////////////////////////////////////////////GJOBAT////////////////////////////////////////////////////////////////////////////////////////*/

                else if (action.payload.endpoint === 'Penalty/GetTicketsForPlate') {
                    state.invoiceList = action.payload.response.tickets.map(ticket => { return { Data: ticket.Date, Serial: ticket.Serie, Vlera: ticket.Value + ' Leke' } })
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = true
                    state.shouldDisplayMainUtilityView = false
                }
                else if (action.payload.endpoint === 'Penalty/GetTicket') {
                    const invoice = action.payload.response.ticket
                    state.singleInvoice = {
                        'Targa': invoice.Plate,
                        'Seriali': invoice.Serie,
                        'Data': invoice.Date,
                        'Vendi': invoice.Place,
                        'Pronari': invoice.Owner,
                        'Marka': invoice.Brand,
                        'Vlera': invoice.Value + ' Leke',
                        'Vlera e kamatës': invoice.Interest + ' Leke',
                        'Zbritja': invoice.Discount + ' Leke',
                        'Komisioni': invoice.Fee + ' Leke',
                        'Vlera totale': invoice.GrossAmount + ' Leke'
                    }

                    state.shouldDisplaySingleInvoice = true
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = false
                }
                else if (action.payload.endpoint === 'Penalty/StartTransaction') {
                    state.transactionId = action.payload.response.transID
                    state.isTransactionSuccessfullyStarted = true
                }
                else if (action.payload.endpoint === 'Penalty/ConfirmTransaction') {
                    state.isTransactionSuccessfullyStarted = false
                    state.isTransactionSuccessfullyCompleted = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = true
                }
                /** //////////////////////////////////////////////////////////////////////QEZHEF////////////////////////////////////////////////////////////////////////*/
                else if (action.payload.endpoint === 'QEZHEF/GetInvoicesForClientQezhefCode') {
                    state.invoiceList = action.payload.response.invoices.map(invoice => { return { Data: invoice.Date, Serial: invoice.Serial, Vlera: invoice.Value + ' Leke' } })
                    state.shouldDisplayInvoiceList = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayMainUtilityView = false
                }
                else if (action.payload.endpoint === 'QEZHEF/GetInvoice') {
                    const invoice = action.payload.response.invoice
                    state.singleInvoice = {
                        'Kodi i klientit': invoice.clientCode,
                        'Emri i kontrates': invoice.clientName,
                        'Data': invoice.documentDate,
                        'Muaji': invoice.month,
                        'Viti': invoice.year,
                        'Seriali': invoice.serial,
                        'Vlera e kamates': invoice.fee + ' Leke',
                        'Vlera': invoice.invoiceValue + ' Leke',
                        'Vlera totale': invoice.totalValue + ' Leke'
                    }

                    state.shouldDisplaySingleInvoice = true
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = false
                }
                else if (action.payload.endpoint === 'QEZHEF/StartTransaction') {
                    state.transactionId = action.payload.response.transID
                    state.isTransactionSuccessfullyStarted = true
                }
                else if (action.payload.endpoint === 'QEZHEF/ConfirmTransaction') {
                    state.isTransactionSuccessfullyStarted = false
                    state.isTransactionSuccessfullyCompleted = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = true
                }
                /** //////////////////////////////////////////////////////////////////////DIGICOM////////////////////////////////////////////////////////////////////////*/
                else if (action.payload.endpoint === 'DIGICOM/GetInvoicesForCustomerID') {
                    state.invoiceList = action.payload.response.invoices.map(invoice => { return { Muaji: invoice.invoicePeriodString, Serial: invoice.serial, Vlera: invoice.invoiceValue + ' Leke' } })
                    state.shouldDisplayInvoiceList = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayMainUtilityView = false
                }
                else if (action.payload.endpoint === 'DIGICOM/GetInvoiceForInvoiceID') {
                    const invoice = action.payload.response.invoice
                    state.singleInvoice = {
                        'Numri i kontrates': invoice.customerID,
                        'Muaji': invoice.invoicePeriodString,
                        'Serial': invoice.invoiceID,
                        'Komisioni': invoice.fee + ' Leke',
                        'Vlera': invoice.invoiceValue + ' Leke',
                        'Vlera totale': invoice.invoiceValue + ' Leke',
                    }

                    state.shouldDisplaySingleInvoice = true
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = false
                }
                else if (action.payload.endpoint === 'DIGICOM/StartTransaction') {
                    state.transactionId = action.payload.response.transID
                    state.isTransactionSuccessfullyStarted = true
                }
                else if (action.payload.endpoint === 'DIGICOM/ConfirmTransaction') {
                    state.isTransactionSuccessfullyStarted = false
                    state.isTransactionSuccessfullyCompleted = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = true
                }
        /** //////////////////////////////////////////////////////////////////////FIRSTCOM////////////////////////////////////////////////////////////////////////*/
        else if(action.payload.endpoint === 'Firstcom/GetClientsForContractFirstCom')
            {         
                state.invoiceList = action.payload.response.clients.map(client => { return { Id: client.id, Detaje: client.info }})
                state.shouldDisplayInvoiceList = true
                state.shouldDisplaySingleInvoice = false
                state.shouldDisplayMainUtilityView = false        
            }
            else if(action.payload.endpoint === 'Firstcom/GetClientFirstComById')
            {
                const invoice = action.payload.response.client
                state.singleInvoice = {
                    'Numri i kontrates': invoice.Id, 
                    'Klienti': invoice.client,
                    'Numri i celularit': invoice.mobile,
                    'Qyteti': invoice.city,
                    'Vlera': invoice.firstComServicePrice + ' Leke',
                    'Komisioni': invoice.fee + ' Leke',
                    'Vlera totale': invoice.firstComServicePrice + ' Leke',
                }

                state.shouldDisplaySingleInvoice = true
                state.shouldDisplayInvoiceList = false
                state.shouldDisplayMainUtilityView = false    
            }
            else if(action.payload.endpoint === 'Firstcom/StartTransactionFirstcom')
            {
                state.transactionId = action.payload.response.transID
                state.isTransactionSuccessfullyStarted = true
            }
            else if(action.payload.endpoint === 'Firstcom/ConfirmTransactionFirstcom')
            {
                state.isTransactionSuccessfullyStarted = false
                state.isTransactionSuccessfullyCompleted = true
                state.shouldDisplaySingleInvoice = false
                state.shouldDisplayInvoiceList = false
                state.shouldDisplayMainUtilityView = true
            }
                /** //////////////////////////////////////////////////////////////////////ABISSNET////////////////////////////////////////////////////////////////////////*/
                else if (action.payload.endpoint === 'Abissnet/StartTransactionAbissnet') {
                    const invoice = action.payload.response
                    state.transactionId = invoice.transID
                    state.singleInvoice = {
                        'Emri i klientit': invoice.clientName,
                        'Muajt e paguar': invoice.payedMonths,
                        'Komisioni': invoice.fee + ' Leke',
                        'Vlera': invoice.price + ' Leke',
                        'Vlera totale': invoice.totalValue + ' Leke'
                    }
                    state.isTransactionSuccessfullyStarted = true
                    state.shouldDisplaySingleInvoice = true
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = false
                }
                else if (action.payload.endpoint === 'Abissnet/ConfirmTransactionAbissnet') {
                    state.isTransactionSuccessfullyStarted = false
                    state.isTransactionSuccessfullyCompleted = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = true
                }
                /** //////////////////////////////////////////////////////////////////////Albtelecom faturat////////////////////////////////////////////////////////////////////////*/
                else if (action.payload.endpoint === 'ALBTELECOM/GetInvoicesForContract') {
                    state.invoiceList = action.payload.response.invoices.map(invoice => { return { Muaji: invoice.Date, Serial: invoice.Serial, Vlera: invoice.Value + ' Leke' } })
                    state.shouldDisplayInvoiceList = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayMainUtilityView = false
                }
                else if (action.payload.endpoint === 'ALBTELECOM/GetInvoiceAlbtelecom') {
                    const invoice = action.payload.response.invoice
                    state.singleInvoice = {
                        'Kontrata': invoice.ContractAccount,
                        'Serial': invoice.InvoiceSerialNr,
                        'Emri': invoice.BusinessPartnerName,
                        'Muaji': invoice.InvoiceDate,
                        'Komisioni': invoice.fee + ' Leke',
                        'Vlera': invoice.InvoiceAmount + ' Leke',
                        'Vlera totale': invoice.totalValue + ' Leke',
                    }

                    state.shouldDisplaySingleInvoice = true
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = false
                }
                else if (action.payload.endpoint === 'ALBTELECOM/StartTransactionAlbtelecom') {
                    state.transactionId = action.payload.response.transID
                    state.isTransactionSuccessfullyStarted = true
                }
                else if (action.payload.endpoint === 'ALBTELECOM/ConfirmTransactionAlbtelecom') {
                    state.isTransactionSuccessfullyStarted = false
                    state.isTransactionSuccessfullyCompleted = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = true
                }
                /** //////////////////////////////////////////////////////////////////////UJESJELLES////////////////////////////////////////////////////////////////////////*/
                else if (action.payload.endpoint === 'UK/GetInvoicesUK') {
                    state.invoiceList = action.payload.response.invoices.map(invoice => { return { Muaji: invoice.Date, Serial: invoice.Serial, Sherbimi: invoice.Service, Vlera: invoice.Value + ' Leke' } })
                    state.shouldDisplayInvoiceList = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayMainUtilityView = false
                }
                else if (action.payload.endpoint === 'UK/GetInvoiceUK') {
                    const invoice = action.payload.response.invoice

                    state.singleInvoice['Seria'] = invoice.Serial
                    invoice.Dictionary.forEach(element => {
                        if (element.Key !== 'Seria:' && element.Key !== 'Totali:') {
                            state.singleInvoice[element.Key.replace(':', '')] = element.Value
                        }
                    })
                    state.singleInvoice['Vlera totale'] = invoice.TotalValue + ' Leke'

                    state.shouldDisplaySingleInvoice = true
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = false
                }
                else if (action.payload.endpoint === 'UK/StartTransactionUK') {
                    state.transactionId = action.payload.response.transID
                    state.isTransactionSuccessfullyStarted = true
                }
                else if (action.payload.endpoint === 'UK/ConfirmTransactionUK') {
                    state.isTransactionSuccessfullyStarted = false
                    state.isTransactionSuccessfullyCompleted = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = true
                }
                /**/////////////////////////////////////Taksat Vendore Offline /////////////////////////////////////////////////////////////////////////////////////////////////////////// */
                if (action.payload.endpoint === 'TAKSAVENDORE/GetListOfTaxes') {
                    state.listOfTaxes = action.payload.response.taxes
                }
                else if (action.payload.endpoint === 'TAKSAVENDORE/StartTransactionTaxes') {
                    const invoice = action.payload.response
                    state.transactionId = invoice.transID
                    state.singleInvoice = {
                        'Nr i transaksioneve': invoice.transactionsSummary.NoOfTrans,
                        'Komisioni': invoice.transactionsSummary.TotalFee + ' Leke',
                        'Vlera': invoice.transactionsSummary.NetAmount + ' Leke',
                        'Vlera totale': invoice.transactionsSummary.GrossAmount + ' Leke'
                    }
                    // state.isTransactionSuccessfullyStarted = true
                    state.shouldDisplaySingleInvoice = true
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = false

                }
                else if (action.payload.endpoint === 'TAKSAVENDORE/ConfirmTransactionTaxes') {
                    state.isTransactionSuccessfullyStarted = false
                    state.isTransactionSuccessfullyCompleted = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = true
                }
                /**/////////////////////////////////////Siguracionet/////////////////////////////////////////////////////////////////////////////////////////////////////////// */
                if (action.payload.endpoint === 'GetFranshizaSHU') {
                    state.franchaise = action.payload.response.franshiza[0].franshiza
                    state.transactionId = action.payload.response.transID
                }
                else if (action.payload.endpoint === 'GetZonaSHU') {
                    state.zone = action.payload.response.zona[0].zona
                }
                else if (action.payload.endpoint === 'GetSeksioneSHU') {
                    state.sections = action.payload.response.seksionet[0].seksione
                }
                else if (action.payload.endpoint === 'GetPrimSHU') {
                    state.prims = action.payload.response.prims
                }
                else if (action.payload.endpoint === 'StartTransactionSHU') {
                    const invoice = action.payload.response
                    state.transactionId = invoice.transID
                    state.singleInvoice = {
                        'Id': action.payload.response.transID,
                        'Kompania': state.extraData.service,
                        'Vlera totale': state.extraData.prim + ' Leke'
                    }
                    state.isTransactionSuccessfullyStarted = true
                    state.shouldDisplaySingleInvoice = true
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = false

                }
                else if (action.payload.endpoint === 'ConfirmTransactionSHU') {
                    state.isTransactionSuccessfullyStarted = false
                    state.isTransactionSuccessfullyCompleted = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = true
                }
                /** //////////////////////////////////////////////////////////////////////EVENTE////////////////////////////////////////////////////////////////////////*/
                else if (action.payload.endpoint === 'GetTicketEvents') {
                    state.events = action.payload.response.events
                }
                else if (action.payload.endpoint === 'GetPartners') {
                    state.partners = action.payload.response.partners
                }
                /** //////////////////////////////////////////////////////////////////////EVENTE////////////////////////////////////////////////////////////////////////*/
                else if (action.payload.endpoint === 'CreateUanatacaRequest') {
                    state.isUanatacaCreated = action.payload.response.success
                }
                else if (action.payload.endpoint === 'GetContract') {
                    state.bytes = action.payload.response.bytes
                }
                else if (action.payload.endpoint === 'SignatureAcceptanceAndSMSConfirm') {
                    state.isSignatureConfirmed = action.payload.response.success
                }
                else if (action.payload.endpoint === 'Onboarding/PostPassiveLiveness') {
                    state.isSelphiCompleted = action.payload.response.success
                }
                else if (action.payload.endpoint === 'Onboarding/AuthenticateFacial') {
                    state.isSelphIDCompleted = action.payload.response.success
                }
                else if (action.payload.endpoint === 'CheckFacePhi') {
                    state.checkFacePhiResponse = action.payload.response
                }
                /** //////////////////////////////////////////////////////////////////////FSHATI-SOS////////////////////////////////////////////////////////////////////////*/
                else if (action.payload.endpoint === 'FshatiSOS/StartTransactionFshatiSos') {
                    state.transactionId = action.payload.response.transID
                }
            })

    },
})
export const { displayInvoiceList, displaySingleInvoice, setSentFrom, setOsheeInvoiceType, setExtraInvoiceListData, setIsTransactionSuccessfullyStarted, clearUtilitySliceStateForBasicAccount, displayMainUtilityView, setRequestData, clearUtilitySliceState, changeConfirmationDialogState, setUtilityName, setExtraData, setIsSelphiCompleted, setIsSelphIDCompleted, setOperationId, setSessionId, openUanatacaDialog, closeUanatacaDialog, openScaDialog, closeScaDialog, setStartTransactionResponse, setPin, setTransId, setScaRequired, setIsScaCompleted } = utilitySlice.actions;

export const selectUtilityState = (state) => state.utility;

export default utilitySlice.reducer;

